/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var CampaignAudience;
(function (CampaignAudience) {
    CampaignAudience["ALL_CUSTOMERS"] = "All Customers";
    CampaignAudience["MEMBER_CUSTOMERS"] = "Member Customers";
    CampaignAudience["NEW_CUSTOMERS"] = "New Customers";
    CampaignAudience["EXISTING_CUSTOMERS"] = "Existing Customers";
    CampaignAudience["CHURNED_CUSTOMERS"] = "Churned Customers";
    CampaignAudience["CUSTOM"] = "Custom";
    CampaignAudience["UNKNOWN"] = "Unknown";
})(CampaignAudience || (CampaignAudience = {}));
